import { render } from "./ReusableContactsTable.vue?vue&type=template&id=f0d3e08c"
import script from "./ReusableContactsTable.vue?vue&type=script&lang=js"
export * from "./ReusableContactsTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__